import { useEffect, useState } from "react";
import { Box, Button, Typography, Zoom } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { freshDesk } from "./freshDesk";

const FreshDeskBtn: React.FC = () => {
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    if (typeof window.FreshworksWidget === "function") {
      window.FreshworksWidget("on", "widget:loaded", () => {
        window.FreshworksWidget?.("hide", "launcher");
      });
    }
  }, []);

  /* Función para inicializar el widget 'freshDesk' para soporte */
  useEffect(() => {
    freshDesk();
  }, []);

  const handleOpenChat = () => {
    if (typeof window.FreshworksWidget === "function") {
      window.FreshworksWidget("open");
    }
  };

  return (
    <Zoom in>
      <Box
        sx={{
          position: "fixed",
          bottom: 24,
          right: 24,
          zIndex: 1300,
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <Button
          onClick={handleOpenChat}
          variant="contained"
          startIcon={
            <HelpOutlineIcon
              sx={{
                width: hovered ? 32 : 32,
                height: hovered ? 32 : 32,
                color: hovered ? "#336B87" : "#fff",
                ml: 1,
              }}
            />
          }
          sx={{
            backgroundColor: hovered ? " #ffffffff !important" : "#F8AD0C",
            color: hovered ? "#336B87" : "#fff",
            textTransform: "none",
            height: 62,
            minWidth: hovered ? 220 : 110,
            fontSize: hovered ? 18 : 18,
            fontWeight: 600,
            fontFamily: "Montserrat",
            padding: hovered ? "8px 20px" : "8px",
            borderTopLeftRadius: "30px",
            borderTopRightRadius: "12px",
            borderBottomRightRadius: "30px",
            borderBottomLeftRadius: "30px",
            border: hovered ? "3px solid #F8AD0C" : "none",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
            overflow: "hidden",
            transition: "all 0.3s ease-in-out",
            "& .fade-text": {
              opacity: 1,
              transition: "opacity 0.3s ease",
            },
            "&:hover .fade-text": {
              opacity: 0,
            },
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            {/* Texto AYUDA */}
            <Typography
              component="span"
              sx={{
                position: "absolute",
                fontSize: 18,
                opacity: hovered ? 0 : 1,
                transform: hovered ? "translateY(-10%)" : "translateY(0%)",
                transition: "opacity 0.3s ease, transform 0.3s ease",
                transitionDelay: hovered ? "0s" : "0.3s",
                pointerEvents: "none",
              }}
            >
              Ayuda
            </Typography>

            {/* Texto SOPORTE UMMIA */}
            <Typography
              component="span"
              sx={{
                position: "absolute",
                opacity: hovered ? 1 : 0,
                fontSize: 18,
                transform: hovered ? "translateY(0%)" : "translateY(10%)",
                transition: "opacity 0.3s ease, transform 0.3s ease",
                transitionDelay: hovered ? "0.3s" : "0s",
                pointerEvents: "none",
              }}
            >
              Soporte UmmIA
            </Typography>
          </Box>
        </Button>
      </Box>
    </Zoom>
  );
};

export default FreshDeskBtn;
